<ng-container *ngIf="product$ | async as product">
  <div class="pdp-tile-container">
  <div *ngIf="!product.failed" class="product-tile" [attr.data-testing-sku]="product.sku">
    <div class="product-image-container icsa-image-container product-item-quick-order-grid">
      <div
        *ngFor="let view of getImagesViews(product); let i = index"
        class="product-img-wrapp {{ i === 0 ? 'primary-image' : 'secondary-image' }}"
      >
        <div class="image-hover-wrapper">
          <ish-product-image imageType="M" [imageView]="view" [link]="true"></ish-product-image>
          <ul class="product-quick-order-hover-btns">
            <li>
              <button *ishFeature="'quickView'" (click)="openQuickView(product.sku)">
                <span><i class="icon-eye"></i></span> <span>Quick View</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
      <ish-product-label></ish-product-label>
      <custom-product-marketing-label></custom-product-marketing-label>
    </div>

    <div class="product-tile-home">
      <span class="product-tile-name">
        <ish-product-name></ish-product-name>
      </span>
      <span class="float-right product-tile-buttons">
        <ish-lazy-product-add-to-order-template [cssClass]="'btn btn-link mr-0'" displayType="icon">
        </ish-lazy-product-add-to-order-template>
        <ish-lazy-product-add-to-wishlist cssClass="btn btn-link" displayType="icon"></ish-lazy-product-add-to-wishlist>
        <ish-lazy-product-add-to-compare displayType="icon" cssClass="btn-link"></ish-lazy-product-add-to-compare>
        <ish-lazy-product-add-to-quote
          *ishFeature="'quoting'"
          [displayType]="'icon'"
          [cssClass]="'btn btn-link'"
        ></ish-lazy-product-add-to-quote>
      </span>
    </div>

    <div
      class="price-adjustment-in-tab position-relative overflow-hidden"
      [ngClass]="{ 'pt-1': !isMasterProduct, 'pb-3': !isMasterProduct }"
    >
      <div *ngIf="configuration$('price') | async" [ngClass]="{ 'price-container': !isMasterProduct }">
        <ish-product-price [showInformationalPrice]="true"></ish-product-price>
      </div>
    </div>
    <ish-product-add-to-basket displayType="plaintext" cssClass="add-to-cart btn-link"> </ish-product-add-to-basket>

    <ish-product-item-variations [showVisible]="false"></ish-product-item-variations>
  </div>
</div>
</ng-container>
